import "./Toast.css";
import { useState, useEffect } from 'react';
import CloseWhiteicon from "../../images/CloseWhiteicon";

const Toast = props => {
    const { toastList, position, autoDelete, autoDeleteTime } = props;
    const [list, setList] = useState(toastList);
    useEffect(() => {
        setList([...toastList]);
    }, [toastList]);
    const deleteToast = id => {
        const listItemIndex = list.findIndex(e => e.id === id);
        const toastListItem = toastList.findIndex(e => e.id === id);
        list.splice(listItemIndex, 1);
        toastList.splice(toastListItem, 1);
        setList([...list]);
    }
    useEffect(() => {
        const interval = setInterval(() => {
            if (autoDelete && toastList.length && list.length) {
                deleteToast(toastList[0].id);
            }
        }, autoDeleteTime);
        return () => {
            clearInterval(interval);
        }
    }, [toastList, autoDelete, autoDeleteTime, list]);

    return (
        <div className={`toast_notification-container ${position}`} >
            {
                list.map((toast, index) =>
                    <div
                        key={index}
                        className={`toast_notification toast_block ${position}`}
                        style={{ backgroundColor: toast.backgroundColor }}
                    >
                        <button onClick={() => deleteToast(toast.id)} >
                            <CloseWhiteicon />
                        </button>
                        <div className="toast_notification-image">
                            <img src={toast.icon} alt="i" />
                        </div>
                        <div>
                            <p className="toast_notification-title">{toast.title}</p>
                            <p className="toast_notification-message"> {toast.description} </p>
                        </div>
                    </div>
                )
            }
        </div>
    )
}
export default Toast;